import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

/**
 * The amber form submit button — one style (incl. the `:focus-visible` ring) for every form
 * that submits through it: `<button bodyanalyticsFormSubmit type="submit">Save</button>`.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'button[bodyanalyticsFormSubmit]',
  host: { class: 'form-submit' },
  template: '<ng-content />',
  styleUrls: ['./form-submit-button.component.scss'],
})
export class FormSubmitButtonComponent {}
